// extracted by mini-css-extract-plugin
export default {"link":"sidebarMenu_link__+2WCj","linkIcon":"sidebarMenu_linkIcon__KhXyT"};